import classnames from 'classnames'

import './globalStyleOverrides.scss'

const GlobalStyleOverrides = props => <div {...props} className={classnames('global-style-overrides', props.className)} />

export default GlobalStyleOverrides
